<template>
    <div class="list-slot"
         :class="{ 'list-slot--disabled': disabled || placeholder, 'list-slot--selected': selected, 'list-slot--no-wrap': noWrap, 'placeholder list-slot--placeholder': placeholder, 'list-slot--instant': instant, 'list-slot--centralised': centralise, 'list-slot--arrow': !noArrow }"
         v-on:click="click">

        <div class="list-slot__inner" v-if="!placeholder">
            <span class="list-slot__title" :title="mainText">
                {{ mainText }}
                <span v-if="mainDetail" class="list-slot__title-detail">
                    {{ mainDetail }}
                </span>
            </span>

            <span class="list-slot__subtitle" :class="{'list-slot--with-icon': shouldShowIcon }" :title="subText" v-if="subText != null">
                <svg class="list-slot__icon" width="13" height="13" :title="subText" v-if="instant" viewBox="0 0 1792 1792">
                    <path d="M1333 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"/>
                </svg>

                <span>{{ subText }}</span>
            </span>

            <div class="list-slot__offers" v-if="offers && offers.length && !disabled">
                <div class="list-slot-offers-titles">
                    <div v-for="offer in offers" 
                        v-bind:key="offer.id"
                        :title="offer.name">
                        <svg class="list-slot__icon" width="10" height="10" viewBox="0 0 1792 1792">
                            <path d="M576 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm1067 576q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"/>
                        </svg>
                        <span>
                            {{ offer.name }}
                        </span>
                    </div>
                </div>
            </div>

            <span class="list-slot__arrow"
                v-if="!disabled && !noArrow">
                <svg width="8px" height="15px">
                    <path d="M0 0 L8 7.5 L0 15 L0 13.5 L6.5 7.5 L0 1.5"></path>
                </svg>
            </span>
        </div>

        <template v-if="placeholder">
            <div class="list-slot__cover list-slot__cover-1"></div>
            <div class="list-slot__cover list-slot__cover-2"></div>
            <div class="list-slot__cover list-slot__cover-3"></div>
            <div class="list-slot__cover list-slot__cover-4"></div>
            <div class="list-slot__cover list-slot__cover-5"></div>
            <div class="list-slot__cover list-slot__cover-6"></div>
        </template>

    </div>
</template>

<script>
    export default {
      name: 'listSlot',
      props: [
        'mainText',
        'mainDetail',
        'subText',
        'disabled',
        'selected',
        'noWrap',
        'placeholder',
        'instant',
        'noArrow',
        'centralise',
        'offers'
      ],
      mounted () {
      },
      methods: {
        click () {
          if (this.disabled) {
            return this.$emit('disabledClick')
          }

          this.$emit('click')
        }
      },
      computed: {
        shouldShowIcon () {
          return this.instant && !this.disabled
        },
        shouldShowOffers () {
          return this.offers && this.offers.length && !this.disabled
        }
      }
    }
</script>



// WEBPACK FOOTER //
// listSlot.vue?4899881e